module.exports = __webpack_public_path__ + "img/p1-2-1.4ad27c8c.png";